import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "layer"
    }}>{`Layer`}</h1>
    <p>{`An object within a document that contains visual elements of the image, equivalent to a layer in Photoshop.`}</p>
    <p>{`You can access layers in a document using `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#layers"
      }}>{`Document.layers`}</a>{` collection.`}</p>
    <p>{`If the object is representing a group layer, you can access it's children layers using `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/#layers"
      }}>{`Layer.layers`}</a>{` property.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`allLocked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When set to true, prevents edits to pixels and properties of this layer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`blendMode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#blendmode"
            }}><em parentName="a">{`BlendMode`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The blend mode of the layer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bounds`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/bounds/"
            }}><em parentName="a">{`Bounds`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Bounds of the layer, including the effects`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boundsNoEffects`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/bounds/"
            }}><em parentName="a">{`Bounds`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Bounds of the layer excluding effects`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`document`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/"
            }}><em parentName="a">{`Document`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The document this layer is in`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`fillOpacity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The fill opacity of the layer, in percentage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`filterMaskDensity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The density of the filter mask, in percentage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`filterMaskFeather`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The feather of the filter mask between 0.0 and 1000.0.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ID of the layer, can be used for making batchPlay calls`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isBackgroundLayer`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isClippingMask`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Is the mask used as a clipping mask.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`kind`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#layerkind"
            }}><em parentName="a">{`LayerKind`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Kind of the layer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`layerMaskDensity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The density of the layer mask, in percentage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`layerMaskFeather`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The feather of the layer mask between 0.0 and 1000.0.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`layers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layers/"
            }}><em parentName="a">{`Layers`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The layers of this group layer `}{`\``}{`\``}{`\``}{`javascript group.layers.forEach((layer) `}{`=`}{`>`}{` {   ... }) `}{`\``}{`\``}{`\``}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`linkedLayers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layers/"
            }}><em parentName="a">{`Layers`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Layers linked to this layer. See `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/#link"
            }}>{`Layer.link`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`locked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True if any property of this layer is locked`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the layer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`opacity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The master opacity of the layer, in percentage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The group layer this layer is in, null if the layer is a top layer in the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pixelsLocked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When set to true, prevents the pixels of this layer from being edited`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`positionLocked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When set to true, prevents the layer from being moved`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`transparentPixelsLocked`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When set to true, prevents the transparent pixels from being edited`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced Layer object`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`vectorMaskDensity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The density of the vector mask, in percentage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`vectorMaskFeather`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The feather of the vector mask between 0.0 and 1000.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`visible`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True when the layer is visible.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "bringtofront"
    }}>{`bringToFront`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Moves the layer to a position above the topmost layer or group.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "clear"
    }}>{`clear`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Clears the layer pixels and does not copy to the clipboard.
If no pixel selection is found, select all pixels and clear.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "copy"
    }}>{`copy`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Copies the layer to the clipboard. When the optional argument is set to true, a
merged copy is performed (that is, all visible layers are copied to the clipboard).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await layer.copy(true)
await layer.copy()
`}</code></pre>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`merge?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "cut"
    }}>{`cut`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Cuts the layer to the clipboard. If no selection is found then select all the pixels and then cut.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "delete"
    }}>{`delete`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Deletes this layer from the document.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const layers = document.layers
layers && layers[0] && layers[0].delete()
`}</code></pre>
    <hr></hr>
    <h3 {...{
      "id": "duplicate"
    }}>{`duplicate`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Duplicates the layer, creating a copy above it in layer stack,
and returns the newly created layer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// duplicate a layer
const copyLayer = await layer.duplicate()

// extract to a new document
const exportDoc = psApp.documents[1]
const exportedLayer = await layer.duplicate(exportDoc)
`}</code></pre>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`relativeObject?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/"
            }}><em parentName="a">{`Document`}</em></a>{` `}{`|`}{` `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`insertionLocation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#elementplacement"
            }}><em parentName="a">{`ElementPlacement`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "flip"
    }}>{`flip`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Flips the layer on one or both axis.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// flip horizontally
await layer.flip.horizontal()
`}</code></pre>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`axis`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"horizontal"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"vertical"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"both"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Which axis (or both) to flip the layer on.             - "horizontal": flip layer on horizontal axis             - "vertical": flip layer on vertical axis             - "both": flip layer on both axes`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "link"
    }}>{`link`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`[]`}</p>
    <p>{`Creates a link between this layer and the target layer if not already linked,
and returns a list of layers linked to this layer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// link two layers together
const linkedLayers = strokes.link(fillLayer)
linkedLayers.forEach((layer) => console.log(layer.name))
> "strokes"
> "fillLayer"
`}</code></pre>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`targetLayer`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "merge"
    }}>{`merge`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Merges layers. This operates on the currently selected layers. If multiple
layers are selected, they will be merged together. If one layer is selected,
it is merged down with the layer beneath. In this case, the layer below must
be a pixel layer. The merged layer will now be the active layer.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "move"
    }}>{`move`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Moves the layer relative to the layer specified in parameters.
"placeAfter" places the layer below relativeObject.
"placeBefore" places the layer above relativeObject.
"placeInside" places the layer inside relativeObject if relativeObject is a group layer.
`}<inlineCode parentName="p">{`ElementPlacement.PLACEINSIDE`}</inlineCode>{` is only valid when `}<inlineCode parentName="p">{`relativeObject.kind === LayerKind.group`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`relativeObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`insertLocation`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#elementplacement"
            }}><em parentName="a">{`ElementPlacement`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "rasterize"
    }}>{`rasterize`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Converts the targeted contents in the layer into a flat, raster image.`}</p>
    <h4 {...{
      "id": "parameters-5"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`target`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#rasterizetype"
            }}><em parentName="a">{`RasterizeType`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "rotate"
    }}>{`rotate`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Rotates the layer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// rotate 90 deg counter clockwise
await layer.rotate(-90)

// rotate 90 deg clockwise relative to top left corner
let anchorPos = require('photoshop').constants.AnchorPosition
await layer.rotate(90, anchorPos.TOPLEFT)
`}</code></pre>
    <h4 {...{
      "id": "parameters-6"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`angle`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Angle to rotate the layer by in degrees`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`anchor?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#anchorposition"
            }}><em parentName="a">{`AnchorPosition`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Anchor position to rotate around`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#resamplemethod"
            }}><em parentName="a">{`ResampleMethod`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Interpolation method to use when resampling the image`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "scale"
    }}>{`scale`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Scales the layer.
Renamed from `}<inlineCode parentName="p">{`resize`}</inlineCode>{` in ExtendScript.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await layer.scale(80, 80)

// Scale the layer to be a quarter of the size relative to bottom left corner
let anchorPos = require('photoshop').constants.AnchorPosition
await layer.scale(50, 50, anchorPos.BOTTOMLEFT)
`}</code></pre>
    <h4 {...{
      "id": "parameters-7"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric percentage to scale layer horizontally`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric percentage to scale layer vertically`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`anchor?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#anchorposition"
            }}><em parentName="a">{`AnchorPosition`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Anchor position to rotate around`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#resamplemethod"
            }}><em parentName="a">{`ResampleMethod`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Interpolation method to use when resampling the image`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "sendtoback"
    }}>{`sendToBack`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Moves the layer to the bottom. If the bottom layer is the
background, it will move the layer to the position above the background.
If it is in a group, it will move to the bottom of the group.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "skew"
    }}>{`skew`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Applies a skew to the layer.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// parellelogram shape
await layer.skew(-15, 0)
`}</code></pre>
    <h4 {...{
      "id": "parameters-8"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`angleH`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Horizontal angle to skew by`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`angleV`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Vertical angle to skew by`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#resamplemethod"
            }}><em parentName="a">{`ResampleMethod`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "translate"
    }}>{`translate`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Moves the layer (translation).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Translate the layer to the left by 200px
await layer.translate(-200, 0)

// move the layer one height down
let xOffsetPct = {_unit: "percentUnit", _value: 0};
let yOffsetPct = {_unit: "percentUnit", _value: 100};
await layer.translate(xOffsetPct, yOffsetPct);
`}</code></pre>
    <h4 {...{
      "id": "parameters-9"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` PercentValue `}{`|`}{` PixelValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value to offset layer by in pixels or percent`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`vertical`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{` `}{`|`}{` PercentValue `}{`|`}{` PixelValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Numeric value to offset layer by in pixels or percent`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "unlink"
    }}>{`unlink`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Unlinks the layer from any existing links.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// detach layer from any existing links
await layer.unlink()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      